module.exports = __webpack_public_path__ + "static/media/back-to-gallery-button.49b48e7a.png";